import useSWR from 'swr';
import { segmentResultCacheKeyGenerator } from './cache';
import { SegmentResult } from 'src/models/segmentResult/type';
import { useSegmentResultRepository } from 'src/repositories/segmentResult/repository';
import { message } from 'antd';
import { LoginAccountState } from 'src/globalStates/loginAccount';

export type SegmentResultGetByBroadCastIdQuery = {
  account: LoginAccountState;
  broadCastId: string;
};

export const useSegmentResult = (query: SegmentResultGetByBroadCastIdQuery) => {
  const repository = useSegmentResultRepository();

  return useSWR<SegmentResult | null>(
    query.broadCastId && query.account.merchantId
      ? segmentResultCacheKeyGenerator.generateByBroadCastIdKey({
          broadCastId: query.broadCastId,
          merchantId: query.account.merchantId.toString(),
        })
      : null,
    async () => {
      if (!query.broadCastId) {
        return null;
      }

      return await repository.getByBroadCastId(query);
    },
    {
      onError: (_) => {
        message.error('セグメント結果の取得に失敗しました。');
      },
    }
  );
};